module.exports = __webpack_public_path__ + "img/society3.f8ac6944.png";